<template>
	<v-container>
		<v-row justify="center">
			<v-col cols="8">
			<v-container class="max-width">
				<v-pagination
					v-model="model"
					class="my-4"
					circle
					color="rgb(0, 160, 227)"
					:length="lengthLocal"
					:total-visible="totalVisibleLocal"
					@input="selectedValuesEmit"
				></v-pagination>
			</v-container>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: 'PaginationCustom',
	props: {
		length: {
			type: Number,
			required: true,
		},
		totalVisible: {
			type: Number,
			default: 9,
		},
	},
	data() {
		return {
			model: 1,
		}
	},
	computed: {
		lengthLocal() {
			return this.length
		},
		totalVisibleLocal() {
			return this.totalVisible
		},
	},
	methods: {
		selectedValuesEmit() {
			this.$emit('modelChanged', this.model)
		},
	},
}
</script>

<style>

</style>
